import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { dataUser } from '../Helpers/util';
import { toast } from 'react-toastify';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';

import dayjs from 'dayjs';

import axiosInstance from '../../utils/axiosInstance';
import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';

const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);

const SeatBookingFilterExport = ({ show, onClose }) => {
  const [locations, setLocations] = useState([]);
  const [customDate, setCustomDate] = useState({
    startDate: null,
    endDate: null,
    selectedLocations: [],
  });
  const [customErrors, setCustomErrors] = useState({});
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [isCustomModalVisible, setIsCustomModalVisible] = useState(false);
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
  });
  const [errors, setErrors] = useState({});
  const [loadingExport, setLoadingExport] = useState(false);

  useEffect(() => {
    fetchLocationsBySpoc();
  }, []);

  const fetchLocationsBySpoc = () => {
    const authToken = JSON.parse(localStorage.getItem('headData'));
    const headers = {
      Authorization: authToken?.spintlyToken,
      'Content-Type': 'application/json',
    };
    axios
      .get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, {
        params: { spoc: UserObj?.rec_id, client: UserObj?.company_id },
        headers,
      })
      .then(res => {
        if (res.data.status === 'success') {
          const formattedLocations = res?.data?.data?.map(location => ({
            label: location.location_name,
            value: location.rec_id,
          }));
          setLocations(formattedLocations);
        }
      })
      .catch(err => console.log('Error fetching locations:', err));
  };

  const handleSelectionChange = selectedOptions => {
    setSelectedLocations(selectedOptions);
  };

  useEffect(() => {
    if (isCustomModalVisible) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [isCustomModalVisible]);

  const handleInputChange = (field, value) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [field]: value ? dayjs(value) : null,
    }));

    if (
      field === 'startDate' &&
      filters.endDate &&
      value &&
      value.isAfter(filters.endDate)
    ) {
      setFilters(prevFilters => ({
        ...prevFilters,
        endDate: null,
      }));
    }
  };

  const validateForm = (startDate, endDate, locations, isCustom = false) => {
    let validationErrors = {};
    if (locations.length === 0)
      validationErrors.location = 'Please select at least one location';
    if (!startDate) validationErrors.startDate = 'Please choose start date';
    if (!endDate) validationErrors.endDate = 'Please choose end date';
    else if (startDate && endDate && endDate.isBefore(startDate, 'day'))
      validationErrors.endDate = 'End date must be on or after start date';
    return validationErrors;
  };

 const handleExport = async e => {
  e.preventDefault();

  const validation = validateForm(
    filters.startDate,
    filters.endDate,
    selectedLocations,
  );

  if (Object.keys(validation).length > 0) {
    setErrors(validation);
    return;
  }

  try {
    setLoadingExport(true);

    const locationIds = selectedLocations.map(loc => loc.value);

    const apiUrl = `${
      process.env.REACT_APP_API_GATEWAYS_URL
    }reports/seat-bookings/getReport/?location_id=[${locationIds.join(
      ',',
    )}]&company_id=${
      UserObj.company_id
    }&from_date=${filters.startDate?.format(
      'YYYY-MM-DD',
    )}&to_date=${filters.endDate?.format('YYYY-MM-DD')}&email=${
      UserObj.email
    }`;

    const response = await axiosInstance.get(apiUrl);

    if (response.status === 200) {
      toast.success('Seat booking data will be sent to your inbox shortly');

      resetForm();   // reset form
      onClose();     // ✅ CLOSE MODAL HERE
    }
  } catch (error) {
    console.error('Error exporting seat booking data:', error);
    toast.error('Failed to export seat booking data');
  } finally {
    setLoadingExport(false);
  }
};


  const resetForm = () => {
    setSelectedLocations([]);
    setFilters({ startDate: null, endDate: null });
    setErrors({});
    setCustomDate({ startDate: null, endDate: null, selectedLocations: [] });
    setCustomErrors({});
  };

  const today = dayjs();
  const minDate = today.subtract(3, 'month').startOf('day');
  const maxDate = today.add(3, 'month').endOf('day');

  const disabledMainStartDate = current => {
    return current && (current < minDate || current > maxDate);
  };

  const disabledMainEndDate = current => {
    return (
      current &&
      (current < minDate ||
        current > maxDate ||
        (filters.startDate && current.isBefore(filters.startDate, 'day')))
    );
  };

  return (
    <>

      <SwOffCanvas
        show={show}
        onClose={() => {
          resetForm();
          onClose();
        }}
        title="Export Seat Booking"
        placement="end"
        backdrop="static"
        keyboard={false}
        footer={
          <div className="OffCanvasFooter_Btns">
            <SwButton variant="dark-outline" onClick={resetForm}>
              Reset
            </SwButton>

            <SwButton
              variant="primary"
              className="ml10"
              onClick={handleExport}
              disabled={loadingExport}
            >
              {loadingExport ? 'Exporting...' : 'Export'}
            </SwButton>
          </div>
        }
      >
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Location Name
                <span className="Required">*</span>
              </label>
              <SwMultiSelect
                id="ESBLocation"
                options={locations}
                value={selectedLocations}
                onChange={handleSelectionChange}
                labelledBy="Select Location"
              />
              <span className="SwTextDanger SwTextSmall">
                {errors.location}
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Start Date <span className="Required">*</span>
              </label>
              <AntDDatePicker
                format="YYYY-MM-DD"
                value={filters.startDate}
                onChange={date => handleInputChange('startDate', date)}
                placeholder="Select Start Date"
                disabledDate={disabledMainStartDate}
              />
              <span className="SwTextDanger SwTextSmall">
                {errors.startDate}
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                End Date <span className="Required">*</span>
              </label>
              <AntDDatePicker
                format="YYYY-MM-DD"
                value={filters.endDate}
                onChange={date => handleInputChange('endDate', date)}
                placeholder="Select End Date"
                disabledDate={disabledMainEndDate}
              />
              <span className="SwTextDanger SwTextSmall">{errors.endDate}</span>
            </div>
          </div>
        </div>

        {/* Buttons */}
      </SwOffCanvas>
    </>
  );
};

export default SeatBookingFilterExport;
